export function PageLoadingFallback() {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center p-8">
      <div className="flex flex-col items-center gap-3">
        <div className="size-8 animate-spin rounded-full border-3 border-teal-500 border-t-transparent" />
        <span className="text-xs font-medium text-slate-400 dark:text-slate-500">
          Memuat halaman...
        </span>
      </div>
    </div>
  );
}
